import { Button, ButtonType, Container } from '../../UI'
import { appStore } from '../../../index'
import * as React from 'react'
import { useEffect } from 'react'
import { Pages } from '../../../Stores/AppStore'
import classes from './Confirmation.module.css'
import { observer } from 'mobx-react-lite'
import { LNG } from '../../../Services/LanguageService';

export const Confirmation = observer(() => {
  const resetCheck = () => {
    if (appStore.dataLoader.isPending) {
      appStore.updateState('resetOnRestore', true)
    }
  }

  useEffect(() => {
    window.addEventListener('beforeunload', resetCheck)
    return () => {
      window.removeEventListener('beforeunload', resetCheck)
    }
  }, [])

  const _onCancelClick = () => {
    appStore.setPage(appStore.errorMessage ? Pages.Home : Pages.ScanPositions)
  }
  const _actions = (
    <>
      <Button label={LNG.Text('scannerApp.21')} onClick={_onCancelClick}/>
    </>
  )

  return (
    <Container actions={_actions} showLoader={appStore.dataLoader.isPending}>
      <div className={classes.root}>
        <div className={classes.title}>{LNG.Text('scannerApp.26')}</div>
        <div className={classes.text}>{appStore.deployedMachine?.acknowledgementText || ''}</div>
        <div className={classes.error} hidden={!appStore.errorMessage}>{appStore.errorMessage}</div>
        <div className={classes.action}>
          <Button type={ButtonType.Primary} label={LNG.Text('scannerApp.26')} onClick={appStore.assignPositions}/>
        </div>
      </div>
    </Container>
  )
})
